import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const AuthorManager = {
  // Get all authors
  async getAllAuthors() {
    const response = await axiosInstance.get("/authors/get");
    return response.data;
  },

  // Get single author by ID
  async getAuthorById(id) {
    const response = await axiosInstance.get(`/authors/get/${id}`);
    return response.data;
  },

  // Add a new author (with optional image)
  async addAuthor(author, authorImage) {
    const formData = new FormData();
    formData.append("author", JSON.stringify(author));
    if (authorImage) {
      formData.append("authorImage", authorImage);
    }
    const response = await axiosInstance.post("/authors/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Update existing author
  async updateAuthor(id, author, authorImage) {
    const formData = new FormData();
    formData.append("author", JSON.stringify(author));
    if (authorImage) {
      formData.append("authorImage", authorImage);
    }
    const response = await axiosInstance.put(`/authors/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Delete an author by ID
  async deleteAuthor(id) {
    const response = await axiosInstance.delete(`/authors/${id}`);
    return response.data;
  },

    // Search authors by name
    async searchAuthorsByName(name) {
      const response = await axiosInstance.get(`/authors/search?name=${name}`);
      return response.data;
    },

};

export default AuthorManager;
